import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Container, Grid, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { db } from '../../config/firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import logoImage from '../../assets/logo_image.png';
import useMediaQuery from '@mui/material/useMediaQuery';

const Footer = () => {
  const navigate = useNavigate();
  const [contactInfo, setContactInfo] = useState({
    address: '',
    phone: '',
    email: ''
  });
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settingsDoc = await getDoc(doc(db, 'settings', 'homepage'));
        if (settingsDoc.exists()) {
          const { contactInfo } = settingsDoc.data();
          setContactInfo(contactInfo);
        }
      } catch (error) {
        console.error('Error fetching contact info:', error);
      }
    };

    fetchSettings();
  }, []);

  return (
    <Box sx={{ bgcolor: 'white', py: 6, borderTop: 1, borderColor: 'divider' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-between">
          {/* Company Info - Left Side */}
          <Grid item xs={12} md={4}>
            <Box 
              component="img"
              src={logoImage}
              alt="Bosphorus Yachts"
              sx={{ 
                width: 40,
                height: 40,
                borderRadius: '50%',
                objectFit: 'cover',
                mb: 1
              }}
            />
            <Typography sx={{ mb: 1 }}>
              Address:<br />
              {contactInfo.address}
            </Typography>
            <Typography sx={{ mb: 1 }}>
              Contact:<br />
              {contactInfo.phone}<br />
              {contactInfo.email}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              {/* <IconButton color="inherit" component="a" href="https://facebook.com/bosphorusyachts" target="_blank" rel="noopener noreferrer"><FacebookIcon /></IconButton> */}
              <IconButton color="inherit" component="a" href="https://www.instagram.com/bosphorusyachts" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><InstagramIcon /></IconButton>
              <IconButton color="inherit" component="a" href="https://twitter.com/bosphorusyachts" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><TwitterIcon /></IconButton>
              {/* <IconButton color="inherit" component="a" href="https://linkedin.com/company/bosphorusyachts" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></IconButton> */}
              <IconButton color="inherit" component="a" href="https://youtube.com/@bosphorusyachts" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><YouTubeIcon /></IconButton>
            </Box>
          </Grid>

          {/* Navigation and Resources - Right Side */}
          <Grid item xs={12} md={7}>
            <Grid container spacing={4} justifyContent="flex-end">
              <Grid item xs={6} md={5}>
                <Typography variant="h6" sx={{ mb: 2 }}>Navigation</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-start' }}>
                  <Button color="inherit" onClick={() => navigate('/explore-yachts')}>Explore Yachts</Button>
                  <Button color="inherit" onClick={() => navigate('/experiences')}>Explore Experiences</Button>
                  {/* <Button color="inherit" onClick={() => navigate('/book-now')}>Book Now</Button> */}
                  {/* <Button color="inherit" onClick={() => navigate('/services')}>Our Services</Button> */}
                  <Button color="inherit" onClick={() => navigate('/blogs')}>Blogs</Button>
                  <Button color="inherit" onClick={() => navigate('/contact')}>Contact Us</Button>
                  <Button 
                    color="inherit" 
                    onClick={() => {
                      if (window.location.pathname !== '/') {
                        navigate('/#faqs');
                      } else {
                        const faqsSection = document.getElementById('faqs');
                        if (faqsSection) {
                          const headerOffset = 80;
                          const elementPosition = faqsSection.getBoundingClientRect().top;
                          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                          window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                          });
                        }
                      }
                    }}
                  >
                    FAQs
                  </Button>
                  <Button color="inherit" href="https://www.bosphorusaffiliates.com">Become an Affiliate</Button>
                </Box>
              </Grid>
              <Grid item xs={6} md={5}>
                <Typography variant="h6" sx={{ mb: 2 }}>Resources</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-start' }}>
                  {/* <Button color="inherit">Testimonials</Button> */}
                  {/* <Button color="inherit">Blog Posts</Button> */}
                  <Button color="inherit" onClick={() => navigate('/explore-yachts')}>Yacht Gallery</Button>
                  <Button color="inherit" onClick={() => navigate('/experiences')}>Experience Gallery</Button>
                  {/* <Button color="inherit">Special Offers</Button> */}
                  {/* <Button color="inherit">Gift Vouchers</Button> */}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Bottom Section */}
        <Box sx={isMobile ? { mt: 4, pt: 4, borderTop: 1, borderColor: 'divider', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' } : { mt: 4, pt: 4, borderTop: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <Typography color="text.secondary"> 2025 Bosphorus Yachts. All rights reserved.</Typography>
          <Box sx={isMobile ? { display: 'flex', flexDirection: 'column' } : { display: 'flex', gap: 2 }}>
            <Button onClick={() => navigate('/terms-of-service#privacy-policy')} color="inherit" size="small">Privacy Policy</Button>
            <Button onClick={() => navigate('/terms-of-service#terms-of-service')} color="inherit" size="small">Terms of Service</Button>
            <Button onClick={() => navigate('/terms-of-service#distance-sales-agreement')} color="inherit" size="small">Distance Sales Agreement</Button>
            {/* <Button onClick={() => navigate('/cookies-settings')} color="inherit" size="small">Cookies Settings</Button> */}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
